import { Trash2, Undo } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { AssetContentTypeEnum } from 'src/graphql/schema';
import { useDepositsSuggestChanges } from 'src/context/suggest-changes';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

type Props = {
  id: string;
  depositSource: string;
  canRemove: boolean;
  type: AssetContentTypeEnum | 'unlabeled';
  isLast: boolean;
};

const AssetActions = ({ id, depositSource, canRemove, type, isLast }: Props) => {
  const { addDeletedAsset, undoAssetDeletion } = useDepositsSuggestChanges();

  if (!canRemove) {
    const onUndo = () => undoAssetDeletion(type, id);

    return (
      <TooltipProvider delayDuration={100}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="ghost" size="icon" className="size-5 px-2" onClick={onUndo}>
              <Undo />
            </Button>
          </TooltipTrigger>
          <TooltipContent
            side="bottom"
            align="center"
            className="bg-popover text-popover-foreground text-sm border border-border"
          >
            Undo
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  if (isLast) {
    return (
      <TooltipProvider delayDuration={100}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="ghost" size="icon" className="size-5 px-2 opacity-30 cursor-not-allowed">
              <Trash2 className="text-destructive" />
            </Button>
          </TooltipTrigger>
          <TooltipContent
            side="top"
            align="center"
            className="max-w-[280px] bg-popover text-popover-foreground text-sm border border-border"
          >
            An active escrow needs to have at least one connected asset.
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  const handleRemoveAsset = () => addDeletedAsset(type, { id, name: depositSource });

  return (
    <Button variant="ghost" size="icon" className="size-5 px-2" onClick={handleRemoveAsset}>
      <Trash2 className="text-destructive" />
    </Button>
  );
};

export default AssetActions;
